/*

REACT BFM EDITOR
(c) 2024 be_smart
written by Marco Aveta
aveta@besmart.it

*/

import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import * as menu from "../../assets/menus/menu.js";
import UserContext from '../../components/User_Context.js';
import { useTranslation } from 'react-i18next';
import "./flow.css";
import ConnectionLine from './connection_line.js';
import { bfm_addEdge } from './bfm_connect.js';
import * as api from "../../api/apiConnector.js";
import { BFM_ToolBar } from "./editor/bfm_toolbar_old.js";
import { useParams } from 'react-router-dom';
import * as uploadManager from "../../components/ui/fileupload.js";
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { IF_Editor } from "./editor/node_if_editor.js";
import { AI_Editor } from "./editor/node_ai_editor.js";
import { Macro_Editor } from "./editor/node_macro_editor.js"
import { RemoteSource_Editor } from "./editor/node_remotesource_editor.js"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import * as utils from "../../components/utils.js";
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import waiting from "../../assets/images/waiting.svg";
import BFM_Toolbar from "./editor/bfm_toolbar.js";

import {
  ReactFlow,
  useNodesState,
  useEdgesState,
  addEdge,
  MiniMap,
  Controls,
  MarkerType,
  Background,
  applyNodeChanges,
  applyEdgeChanges
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import Flow_Block from './bfm_editor_flow_block';
import _default from 'react-bootstrap/esm/Accordion.js';

const BFM_Editor = (params) => {
  const [flow, setFlow] = useState(null);
  const [nodes, setNodes] = useNodesState(null);
  const [edges, setEdges] = useEdgesState(null);
  const { minZoom = 0.1, maxZoom = 15 } = params;
  const { currentUser } = useContext(UserContext);
  const { t } = useTranslation();
  const { id } = useParams();
  const [editingItem, setEditingItem] = useState(null);
  const [schemas, setSchemas] = useState(null);
  const [files, setFiles] = useState(null);
  const [macros, setMacros] = useState(null);
  const [dataSources, setDataSources] = useState(null);
  const [bfmAutocompleteEnabled, setBfmAutoCompleteEnabled] = useState(null);
  const [updatedFlow, setUpdatedFlow] = useState(null);


  let system_message_timer = null;

  //#region chat
  const _parseMessage = (message) => {
    switch (message.type) {
      case "bfm_nodes": {
        setUpdatedFlow(message.flow);
        show_system_message({ message: t('dataUpdated', { ns: 'labels' }) });
      }

        break;
      case "wellcome": {
        window.client.id = message.id;
        _sendMessage({
          type: "authenticate",
          token: currentUser().token,
          data_sources: window.dataSources,
          package_files: window.files
        });

        show_system_message({
          timeOut: 0,
          message: `
                      <strong>${t('connecting', { ns: 'labels' })}</strong>...
                      `});
      }
        break;
      case "authenticated": {
        window.$("#question-area").prop("hidden", null);

        show_system_message({
          message: `
                      <strong>${t('connected', { ns: 'labels' })}</strong>...
                      `});
      }
        break;
      case "chat": {

        show_chat_message({
          message: message.message
        });
      }
        break;
    }
  }

  const _sendMessage = async (message) => {
    if (window.client?.id) {
      message.id = window.client.id;
    }

    var result = await api.sendMessage("bfm/talk", {
      user: currentUser(),
      body: {
        message
      }
    });

    window.$("#current-question-text").text(message.query);
  }

  const show_chat_message = (params) => {
    const { message, timeOut = 5000 } = params;

    const inner_div = window.$(`<div class="col-xl-12">
              <div class="card dz-card">
                  <div class="card-header flex-wrap border-0">
                      <div>
                          <h4 class="card-title">${t('aiPlan', { ns: 'labels' })}</h4>
                      </div>											
                  </div>
                  <div class="tab-content">
                      <div class="tab-pane fade active show" role="tabpanel">
                          <div class="card-body pt-0" style="height: 100%; overflow-y: scroll">
                                                                                                 
                          </div>
                      </div>
                  </div>
              </div>
          </div>`);

    let div = window.$("#chat-system-message");

    if (div.length == 0) {
      div = window.$(`<div id="chat-system-message" style="position: fixed; right: 20px; bottom: 30px; width: 350px; height: 200px; opacity: 0.75"></div>`);
      window.$("body").append(div);
      div.append(inner_div);
    }

    const message_div = div.find(".card-body");
    let text = `${message_div.text()}${message}`;

    message_div.text(text);

    if (system_message_timer) {
      clearTimeout(system_message_timer);
    }

    if (timeOut > 0) {
      system_message_timer = setTimeout(() => {
        div.remove();
      }, timeOut);
    }
  }

  const show_system_message = (params) => {
    const { message, timeOut = 2000 } = params;

    const inner_div = window.$(`<div class="col-xl-12">
              <div class="card dz-card">
                  <div class="card-header flex-wrap border-0">
                      <div>
                          <h4 class="card-title">${t('aiPlan', { ns: 'labels' })}</h4>
                      </div>											
                  </div>
                  <div class="tab-content">
                      <div class="tab-pane fade active show" role="tabpanel">
                          <div class="card-body pt-0">
                              <h6><span></span>
                                  <span class="pull-end"></span>
                              </h6>                                                                        
                          </div>
                      </div>
                  </div>
              </div>
          </div>`);

    let div = window.$("#chat-system-message");

    if (div.length == 0) {
      div = window.$(`<div id="chat-system-message" style="position: fixed; right: 20px; bottom: 30px; width: 350px; height: 200px; opacity: 0.75"></div>`);
      window.$("body").append(div);
      div.append(inner_div);
    }

    const message_div = div.find(".pull-end");


    message_div.html("");
    message_div.append(window.$("<div/>").html(message));

    if (system_message_timer) {
      clearTimeout(system_message_timer);
    }

    if (timeOut > 0) {
      system_message_timer = setTimeout(() => {
        div.remove();
      }, timeOut);
    }
  }

  const startChat = async () => {
    if (!window.client) {
      const _client = new window.EventSource(`${process.env.REACT_APP_API_URL}/bfm/startAI`);
      _client.onmessage = (e) => {

        _parseMessage(JSON.parse(e.data));
      }

      window.client = {
        emitter: _client,
        html: ""
      }

      return _client;
    }
  }
  //#endregion


  const getNodes = async () => {
    var flow_result = await api.sendMessage("bfm/getFlow", {
      user: currentUser(),
      body: {
        id
      }
    });

    setFiles(flow_result.files);
    setMacros(flow_result.macros);
    setDataSources(flow_result.datasources);

    window.files = flow_result.files;
    window.dataSources = flow_result.datasources;

    var result = await api.sendMessage("bfm/getReactFlow", {
      user: currentUser(),
      body: {
        flow: flow_result.flow
      }
    });

    setFlow(flow_result.flow);
    setSchemas(flow_result.schemas);
    setNodes(result.nodes);
    setEdges(result.edges);


    breadcrumb.set(
      [{
        link: "/",
        name: "Home"
      }].concat(
        flow_result.path.reverse().map((f) => {
          return {
            name: f.Name,
            link: `/dms/${f.Id}`
          }
        }))
        .concat(
          {
            link: `/aiflow/data/${id}`,
            name: flow_result.flow.name ?? "flow"
          }
        )
    );
  }

  useEffect(() => {
    (async () => {
      menu.write({ user: currentUser() });
      await getNodes();
      const _chat = await startChat();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (updatedFlow) {
        flow.nodes = updatedFlow.nodes;
        _refreshFlow();
      }
    })();
  }, [updatedFlow]);

  useEffect(() => {
    (async () => {
      _adjustEdges();
    })();
  }, [nodes]);

  useEffect(() => {
    (async () => {
      _adjustEdges();
    })();
  }, [edges]);

  useEffect(() => {
    (async () => {
    })();
  }, [flow]);

  useEffect(() => {
    (async () => {
      if (editingItem) {
        window.$("#editor-details-modal").modal("show");
        window.$("#editor-details-modal").draggable({ handle: ".modal-header" });
      }
    })();
  }, [editingItem]);

  useEffect(() => {
    (async () => {
      if (bfmAutocompleteEnabled) {
        window.$("#chat-bfm-autocomplete").modal("show");
        window.$("#chat-bfm-autocomplete").draggable({ handle: ".modal-header" });
        setTimeout(() => {
          window.$("#bfm-design-chat-text").focus();
        }, 1000);

      } else {
        window.$("#chat-bfm-autocomplete").modal("hide");
        window.$(".modal-backdrop").remove();
      }
    })();
  }, [bfmAutocompleteEnabled]);

  const onConnect = (params) => {
    let _source = flow.nodes.find(x => x.id == params.source);
    if (_source && _source.type == "if") {
      if (!_source.ifTrue) {
        _source.ifTrue = params.target;
        params.label = "TRUE";
        const _edges = addEdge(params, edges);
        setEdges(_edges);
      } else if (!_source.ifFalse) {
        _source.ifFalse = params.target;
        params.label = "FALSE";
        const _edges = addEdge(params, edges);
        setEdges(_edges);
      }
    } else {
      const _edges = addEdge(params, edges);
      setEdges(_edges);
    }
  };

  const _adjustEdges = (_edges) => {
    if (!edges && edges) edges = _edges;
    if (!edges) return;

    for (var e of edges) {
      let _source = nodes.find(x => x.id == e.source);
      let _target = nodes.find(x => x.id == e.target);
      if (_source && _target) {
        e.markerEnd = {
          type: MarkerType.Arrow
        };
        e.animated = true;
        e.style = {
          width: 2
        }
        //x difference
        let _diffx = _target.position.x - _source.position.x;
        let _modulox = _diffx < 0 ? -_diffx : _diffx;

        //y difference
        let _diffy = _target.position.y - _source.position.y;
        let _moduloy = _diffy < 0 ? -_diffy : _diffy;

        //let's play star wars and choose the best quadrant to attack
        //the BLACK DEATH (target)
        /*

        1   2   3

        4   X   6

        7   8   9

        */

        //default
        let _quadrant = 1;

        if (_modulox < _target.width) {
          //horizontaly centered 2 5 8

          if (_diffy > 0) {
            e.sourceHandle = "s_b";
            e.targetHandle = "t_t";
          } else {
            e.sourceHandle = "s_t";
            e.targetHandle = "t_b";
          }
        }
        else {
          if (_moduloy < _target.height) {
            //vertically centered 4 5 6
            if (_diffx < 0) {
              e.sourceHandle = "s_l";
              e.targetHandle = "t_r";
            }
            else {
              e.sourceHandle = "s_r";
              e.targetHandle = "t_l";
            }
          }
          else {
            if (_modulox > _moduloy) {
              if (_diffx < 0) {
                e.sourceHandle = "s_l";
                e.targetHandle = "t_r";
              }
              else {
                e.sourceHandle = "s_r";
                e.targetHandle = "t_l";
              }
            } else {
              if (_diffy > 0) {
                e.sourceHandle = "s_b";
                e.targetHandle = "t_t";
              } else {
                e.sourceHandle = "s_t";
                e.targetHandle = "t_b";
              }
            }
          }
        }
      }
    }
  }

  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => {
      return applyEdgeChanges(changes, eds);
    }),
    [setEdges],
  );

  const onEdgeDoubleClick = (event, edge) => {
    const _node = flow.nodes.find(x => x.id == edge.source);

    if (_node) {
      if (_node.ifTrue == edge.target) {
        _node.ifTrue = _node.ifFalse;
        _node.ifFalse = edge.target;
      }
      else {
        _node.ifFalse = _node.ifTrue;
        _node.ifTrue = edge.target;
      }
    }

    resyncNodesFromFlow({ nodes, edges });
    _refreshFlow();
  };

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => {
      for (var c of changes) {
        let _node = nds.find(x => x.id == c.id);

        if (_node) {
          _node.data.bfm_data = _node.data.bfm_data ?? {};
          _node.data.bfm_data.x = _node.position.x;
          _node.data.bfm_data.y = _node.position.y;
          _node.data.bfm_data.width = _node.width;
          _node.data.bfm_data.height = _node.height;

          if (c.type == "remove") {
            if (_node.data.bfm_data.type == "start"
              || _node.data.bfm_data.type == "stop"
            ) {
              changes.splice(changes.findIndex(x => x === c), 1);
            }
          }
        }


      }
      return applyNodeChanges(changes, nds);
    }),
    [],
  );

  const resyncNodesFromFlow = ({ nodes }) => {
    if (nodes) {
      for (var n of nodes) {
        let _flowNode = flow.nodes.find(x => x.id == n.id);

        if (_flowNode) {
          _flowNode.x = n.position.x;
          _flowNode.y = n.position.y;
          _flowNode.width = n.width;
          _flowNode.height = n.height;
        }
      }

      while (flow.nodes.find(x => !nodes.find(y => y.id == x.id))) {
        flow.nodes.splice(flow.nodes.findIndex(x => !nodes.find(y => y.id == x.id)), 1);
      }
    }

    if (edges) {
      for (var e of edges) {
        let _source = flow.nodes.find(x => x.id == e.source);
        let _target = flow.nodes.find(x => x.id == e.target);

        if (_source.type == "if") {
          if (
            _source.ifTrue != _target?.id
            && _source.ifFalse != _target?.id
          ) {
            _source.ifTrue = _target?.id;
          }
        } else {
          _source.next = _target?.id;
        }
      }
    }

    if (nodes && edges) {
      for (var n of nodes) {
        let _flowNode = flow.nodes.find(x => x.id == n.id);

        if (_flowNode) {
          if (_flowNode.next && !edges.find(y => y.source == _flowNode.id && y.target == _flowNode.next)) {
            _flowNode.next = null;
          }

          if (_flowNode.ifTrue && !edges.find(y => y.source == _flowNode.id && y.target == _flowNode.ifTrue)) {
            _flowNode.ifTrue = null;
          }

          if (_flowNode.ifFalse && !edges.find(y => y.source == _flowNode.id && y.target == _flowNode.ifFalse)) {
            _flowNode.ifFalse = null;
          }
        }
      }
    }
  }

  const _refreshFlow = async () => {
    var result = await api.sendMessage("bfm/getReactFlow", {
      user: currentUser(),
      body: {
        flow: flow
      }
    });

    setFlow(flow);
    setNodes(result.nodes);
    setEdges(result.edges);
    _adjustEdges(result.edges);
  }

  const _addBlock = async (params) => {
    const { type } = params;

    resyncNodesFromFlow({ nodes: nodes, edges: edges });

    let _viewPort = window.flowEditor.getViewport();
    let _rect = window.flowEditorDiv.getBoundingClientRect();

    switch (type) {
      case "if":
      case "execute":
      case "ai":
      case "set":
      case "db":
      case "notes":
      case "macro":
        {
          flow.nodes.push({
            id: `node_${new Date().getTime()}`,
            type: type,
            x: - _viewPort.x / _viewPort.zoom + (_rect.width / 2) / _viewPort.zoom,
            y: - _viewPort.y / _viewPort.zoom + (_rect.height / 2) / _viewPort.zoom,
          });
        }
        break;
    }

    _refreshFlow();
  }

  const _save = async () => {
    resyncNodesFromFlow({ nodes, edges });
    const _file = new File([JSON.stringify(flow)], flow.name);

    uploadManager.fileUpload({
      files: [_file],
      parentId: flow.parentId,
      user: currentUser(),
      onFileAdded: (e) => {
        withReactContent(Swal).fire({
                              title: t('fileSaved', { ns: 'labels' }),
                    icon: "success",
          text: "Your flow was successifully saved",
          showConfirmButton: true
        });
      }
    })
  }

  const _toolBarCommand = async (params) => {
    const { command, argument } = params;

    switch (command) {
      case "ai_design": {
        setBfmAutoCompleteEnabled(true);
      }
        break;
      case "save": {
        _save();
      }
        break;
      case "add_block": {
        _addBlock({ type: argument.type });
      }
        break;
    }
  }

  const _showInnerEdit = (params) => {
    const { node } = params;

    switch (node.type) {
      case "db": {
        return (<RemoteSource_Editor node={node} schemas={schemas} macros={macros} parent={`editor-details-modal`} sources={dataSources} files={files} onChange={(n) => {
          setEditingItem(n);
        }}></RemoteSource_Editor>);
      }
        break;
      case "macro": {
        return (<Macro_Editor node={node} schemas={schemas} macros={macros} parent={`editor-details-modal`} files={files} onChange={(n) => {
          setEditingItem(n);
        }}></Macro_Editor>);
      }
        break;
      case "ai": {
        return (<AI_Editor node={node} schemas={schemas} files={files} parent={`editor-details-modal`} onChange={(n) => {
          setEditingItem(n);
        }}></AI_Editor>);
      }
        break;
      case "if": {
        return (<IF_Editor node={node} schemas={schemas} onChange={(n) => {
          setEditingItem(n);
        }}></IF_Editor>);
      }
        break;
      default:
        {
          return (null);
        }
        break;
    }
  }

  const _showEdit = () => {
    if (!editingItem) return (null);
    return (<>
      <div class="modal fade show modal-xl" id="editor-details-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="editor-details-modal-label">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="editor-details-modal-label">{editingItem.type}</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label={t('close', { ns: 'labels' })} onClick={() => {
                setEditingItem(null);
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) {
                  backdrop.remove();
                }
                document.body.classList.remove('modal-open');
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
              }}></button>
            </div>
            <div class="modal-body">
              {_showInnerEdit({ node: editingItem })}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" onClick={() => {
                setEditingItem(null);
                // Remove modal backdrop
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) {
                  backdrop.remove();
                }
                // Remove modal-open class from body
                document.body.classList.remove('modal-open');
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
              }}>Cancel</button>
              <button type="button" class="btn btn-warning">Test</button>
              <button type="button" class="btn btn-primary" onClick={(e) => {
                const _index = flow.nodes.findIndex(x => x.id == editingItem.id);
                flow.nodes[_index] = editingItem;
                setEditingItem(null);
                resyncNodesFromFlow({ nodes: nodes, edges: edges });
                _refreshFlow();
                // Remove modal backdrop
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) {
                  backdrop.remove();
                }
                // Remove modal-open class from body
                document.body.classList.remove('modal-open');
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
              }}>OK</button>
            </div>
          </div>
        </div>
      </div>
    </>);
  }

  const _showAIDesignModal = () => {
    if (!bfmAutocompleteEnabled) return (null);

    const _send_design_request = async (params) => {
      setBfmAutoCompleteEnabled(false);

      show_system_message({ message: "I'm thinking...", timeOut: 0 });

      let _viewPort = window.flowEditor.getViewport();
      let _rect = window.flowEditorDiv.getBoundingClientRect();

      _sendMessage({
        type: "bfm_design",
        query: window.$("#bfm-design-chat-text").val(),
        flow,
        x: - _viewPort.x / _viewPort.zoom + (_rect.width / 2) / _viewPort.zoom,
        y: - _viewPort.y / _viewPort.zoom + (_rect.height / 2) / _viewPort.zoom,
      });

    }

    return (<>
      <div class="modal fade show modal-xl" id="chat-bfm-autocomplete" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="editor-details-modal-label">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="editor-details-modal-label">{t('design', { ns: 'labels' })}</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label={t('close', { ns: 'labels' })}
                onClick={(e) => {
                  setBfmAutoCompleteEnabled(false);
                }}></button>
            </div>
            <div class="modal-body">
              <textarea id="bfm-design-chat-text" class="form-control" rows={10} onKeyDown={(e) => {
                if (e.key == "Enter") {
                  _send_design_request();
                }
              }} />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={(e) => {
                setBfmAutoCompleteEnabled(false);
              }
              }>Cancel</button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal" onClick={async (e) => {
                _send_design_request();
              }}>OK</button>
            </div>
          </div>
        </div>
      </div>
    </>);
  }

  const _nodeDblClick = async (node) => {
    switch (node.data.bfm_data?.type) {
      case "notes":
      case "start":
      case "stop": {
        //nop
      }
        break;
      default: {
        const _node = utils.clone(flow.nodes.find(x => x.id == node.id));
        setEditingItem(_node);
      }
    }
  }

  const _renderFlow = () => {
    if (edges) {
      _adjustEdges();
    }

    return (
      <>
        <div class="page-titles">
          <ol class="breadcrumb">
          </ol>

          <div>
            <a class="text-warning " onClick={(e) => {
              setBfmAutoCompleteEnabled(true);
                          }} role="button" title={t('saveThisFlow', { ns: 'labels' })}><i class="fa-solid fa-comments fa-2x"></i>
            </a>
            <span style={{ minWidth: "13em", borderLeft: 1, borderLeftColor: "darkgray" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <a class="text-primary " onClick={(e) => {
              _save();
                          }} role="button" title={t('saveThisFlow', { ns: 'labels' })}><i class="fa-solid fa-floppy-disk fa-2x"></i>
            </a>
          </div>

        </div>

        {_showEdit(editingItem)}
        {_showAIDesignModal(bfmAutocompleteEnabled)}
        <ReactFlow
          onInit={(e) => {
            window.flowEditor = e;
          }}
          ref={(e) => {
            window.flowEditorDiv = e
          }}
          minZoom={minZoom}
          maxZoom={maxZoom}
          nodes={nodes}
          edges={edges}
          onEdgeDoubleClick={onEdgeDoubleClick}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          onNodeDoubleClick={(event, node) => {
            _nodeDblClick(node);
          }}
          fitView
          nodeTypes={{
            default: Flow_Block
          }}
        >
          <BFM_Toolbar onCommand={(p) => {
            return _toolBarCommand(p);
          }} />
          {/* <BFM_ToolBar onCommand={(p) => {
            return _toolBarCommand(p);
          }}></BFM_ToolBar> */}
          <MiniMap />
          <Background></Background>
          <Controls />

        </ReactFlow>
      </>
    );
  };


  const _render = () => {
    if (nodes) {
      return (_renderFlow());
    }
    else {
      return (<div class="text-center" style={{ position: "absolute", width: "100%", top: "50%" }}><img src={waiting} /></div>);
    }
  }


  return (
    <div style={{ width: "100%", height: "100vh" }}>
      {_render()}
    </div>
  );
}

export { BFM_Editor };